<nz-modal
  [nzVisible]="settingVisible"
  [nzWidth]="800"
  [nzTitle]="null"
  [nzFooter]="null"
  [nzMaskClosable]="false"
  [nzBodyStyle]="{ padding: '0' }"
  (nzOnCancel)="handleCloseHSCModal()"
>
  <div class="hsc-root">
    <!-- 顶部工具栏 -->
    <div class="hsc-toolbar">
      <span class="hsc-title">图片采集</span>
      <div class="hsc-toolbar-actions">
        <nz-select
          [(ngModel)]="selectedDeviceId"
          (ngModelChange)="openCamera()"
          nzPlaceHolder="选择摄像头"
          [nzLoading]="deviceListLoading"
          style="width: 200px"
        >
          <nz-option
            *ngFor="let device of deviceList"
            [nzValue]="device.deviceId"
            [nzLabel]="device.label || '摄像头'"
          ></nz-option>
        </nz-select>
        <button
          nz-button
          nzType="primary"
          [disabled]="imgPathArray.length < 1"
          (click)="exportFiles()"
        >
          完成{{ imgPathArray.length > 0 ? ' (' + imgPathArray.length + ')' : '' }}
        </button>
      </div>
    </div>

    <!-- 主摄像头区域 -->
    <div class="hsc-stage">
      <video #videoEl autoplay playsinline [style.transform]="videoTransform"></video>
      <!-- 底部控制栏：快门 + 其他按钮 -->
      <div class="hsc-controls">
        <div class="hsc-controls-side hsc-controls-left"></div>
        <button class="hsc-shutter" (click)="cameraScan()">
          <span class="hsc-shutter-inner">
            <i class="icon iconfont icon-camera"></i>
          </span>
        </button>
        <div class="hsc-controls-side hsc-controls-right">
          <div class="hsc-ctrl-row">
            <button class="hsc-ctrl-btn" (click)="rotateVideo()" title="旋转画面">
              <i class="icon iconfont icon-rotate-right"></i>
            </button>
            <button
              class="hsc-ctrl-btn"
              [class.hsc-ctrl-btn--active]="flipH"
              (click)="flipHorizontal()"
              title="水平翻转"
            >
              <i nz-icon nzType="border-horizontal" nzTheme="outline"></i>
            </button>
            <button
              class="hsc-ctrl-btn"
              [class.hsc-ctrl-btn--active]="flipV"
              (click)="flipVertical()"
              title="垂直翻转"
            >
              <i nz-icon nzType="border-verticle" nzTheme="outline"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部胶卷 -->
    <div class="hsc-filmstrip" [class.hsc-filmstrip--empty]="imgPathArray.length === 0">
      <div class="hsc-filmstrip-empty" *ngIf="imgPathArray.length === 0">
        点击快门拍照，照片将在此处显示
      </div>
      <div
        class="hsc-filmstrip-scroll"
        #filmstripScroll
        *ngIf="imgPathArray.length > 0"
        (wheel)="onFilmstripWheel($event)"
      >
        <div *ngFor="let item of imgPathArray; let i = index" class="hsc-film-card">
          <div class="hsc-film-thumb" (click)="openPreview(i)">
            <img [src]="item.src" />
            <div class="hsc-film-hover">
              <i class="icon iconfont icon-zoom-in"></i>
            </div>
          </div>
          <nz-select
            [(ngModel)]="item.fileType"
            nzPlaceHolder="文件类型"
            nzSize="small"
            style="width: 100%; margin-top: 5px"
          >
            <nz-option
              *ngFor="let option of fileTypeList"
              [nzValue]="option.wordValue"
              [nzLabel]="option.wordText"
            ></nz-option>
          </nz-select>
          <button class="hsc-film-delete" (click)="deleteFile(i)">
            <i class="icon iconfont icon-close"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</nz-modal>

<nz-modal
  nzTitle="无法访问摄像头"
  [nzVisible]="cameraErrorVisible"
  [nzFooter]="cameraErrorFooter"
  [nzMaskClosable]="false"
  (nzOnCancel)="cameraErrorVisible = false"
>
  <ng-container *ngIf="cameraErrorType === 'notfound'">
    <p>未检测到摄像头设备，请确认摄像头已正确连接后重试。</p>
  </ng-container>
  <ng-container *ngIf="cameraErrorType === 'permission'">
    <p>
      浏览器拒绝了摄像头访问权限。请确认已授予本页面摄像头权限，若仍无法访问，请按以下步骤将当前地址设为受信任来源：
    </p>
    <ol>
      <li>
        在地址栏输入
        <strong>chrome://flags/#unsafely-treat-insecure-origin-as-secure</strong> 并回车
      </li>
      <li>将右侧下拉框改为 <strong>Enabled</strong></li>
      <li>在输入框中粘贴以下地址并点击"添加"：</li>
    </ol>
    <div
      style="
        background: #f5f5f5;
        padding: 8px 12px;
        border-radius: 4px;
        font-family: monospace;
        word-break: break-all;
      "
    >
      {{ currentOrigin }}
    </div>
    <p style="margin-top: 12px">添加后点击右下角 <strong>Relaunch</strong> 重启浏览器。</p>
  </ng-container>
</nz-modal>
<ng-template #cameraErrorFooter>
  <button nz-button nzType="primary" (click)="cameraErrorVisible = false">我知道了</button>
</ng-template>
